
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/blog",
      function () {
        return require("private-next-pages/learn/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/blog"])
      });
    }
  